import {
    Container, Row, Col
} from "reactstrap";
import React from 'react';
import { RoundedButton, ButtonColor, ButtonCorner } from "../../components/Buttons/RoundedButton";
import printerImg from '../../assets/img/site/printer_label.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { useStore } from "../../utilities/appStore";

const SubscriptionConfirmation = () => {
    let config = useStore((state) => state.Configuration);
    let storeLink = config.ecommerceUrl;
    const downloadDCGAppLink = config.downloadDCGApp;
    const routeChange = () => {
        window.location.href = storeLink;
    }

    const styles = {
        header: {
            border: '1px solid',
            backgroundColor: "var(--base-color-gray-background)",
        },
        link: {
            color: "var(--base-color-teal)"
        }
    }

    return (
        <Container fluid={true} className="text-center">
            <Row className="my-5 justify-content-center">
                <div style={styles.header} className="w-75 py-3">
                    <FontAwesomeIcon icon={faCheck} style={{ color: "var(--base-color-teal)", height: 50, width: 50 }} />
                    <h2>Your subscription is currently being processed!</h2>
                    <p className="mb-0">
                        Please watch your email for confirmation when complete, and gain access to your DateCodeGenie portal.
                    </p>
                    <sub>Use a desktop device to proceed.</sub>
                </div>

            </Row>
            <Row className="">
                <Col>
                    
                    <h2>Download your DateCodeGenie app to your tablet!</h2>
                    <p>Go <a style={styles.link} href={downloadDCGAppLink}>here</a> to download your DateCodeGenie app to each tablet you will be using with DateCodeGenie.</p>
                </Col>
            </Row>
            <Row className="">
                <Col>
                    <img src={printerImg}></img>
                    <h2>Haven't purchased your printers or labels yet?</h2>
                    <p>No problem. Visit <a style={styles.link} href={storeLink}>our store</a> to purchase the right products for your business! </p>
                    <RoundedButton
                        hoverColor={ButtonColor.DarkGrey}
                        hoverTextColor={ButtonColor.White}
                        hoverOutlineColor={ButtonColor.DarkGrey}
                        textColor={ButtonColor.White}
                        buttonColor={ButtonColor.Grey}
                        outlineColor={ButtonColor.Grey}
                        cornerRadius={ButtonCorner.SevenPX}
                        text="Buy Printers & Labels"
                        clickHandler={routeChange} />
                </Col>
            </Row>
        </Container>
    );
};

export default SubscriptionConfirmation;
